import { findInObject } from '@/utils/findInObject';

const BASE_PATHS = {
  COMMON: 'common',
  STRUCTURED: 'data.structured',
  CATALOG: 'catalog',
  METADATA: 'metadata',
  TRANSLATIONS: 'translations',
  ATTRIBUTES: 'attributes',
} as const;

const IP_PATHS = {
  ID: ['_id'],
  NAME: [`${BASE_PATHS.COMMON}.title`],
  IP: [`${BASE_PATHS.STRUCTURED}.ip`, `${BASE_PATHS.ATTRIBUTES}.ip`],
  HOSTNAME: [`${BASE_PATHS.STRUCTURED}.hostname`, `${BASE_PATHS.ATTRIBUTES}.hostname`],
  IS_PRIVATE: [`${BASE_PATHS.STRUCTURED}.is_private`],
  DATACENTERS: [`${BASE_PATHS.STRUCTURED}.datacenters`],
  VPNS: [`${BASE_PATHS.STRUCTURED}.vpns`],
  SOURCE: [`${BASE_PATHS.CATALOG}.source`],
  SOURCE_IDS: [`${BASE_PATHS.CATALOG}.source_ids`],
};

export const normalizeIpAddress = (record: Record<string, any>) => ({
  id: findInObject(record, IP_PATHS.ID),
  name: findInObject(record, IP_PATHS.NAME),
  ip: findInObject(record, IP_PATHS.IP),
  hostname: findInObject(record, IP_PATHS.HOSTNAME),
  is_private: findInObject(record, IP_PATHS.IS_PRIVATE),
  datacenters: findInObject(record, IP_PATHS.DATACENTERS, []),
  vpns: findInObject(record, IP_PATHS.VPNS, []),
  catalog: {
    source: findInObject(record, IP_PATHS.SOURCE, []),
    source_ids: findInObject(record, IP_PATHS.SOURCE_IDS, []),
  },
  raw: record,
});
